import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchOrganizationList,
  login,
  loginWithGoogle,
  CreateOrganization,
  fetchOrganizationDetails,
  CreateUser,
  getUserAccountDetails,
  fetchOrganizationHierarchy,
  fetchOrganizationSummary,
} from "../../services/OrganizationService";
import { Pagination } from "../../types/CommonType";
import { fetchUserStats } from "../../services/OrganizationService";

export const fetchOrganizationListAsync = createAsyncThunk(
  "user/fetchOrganizations",
  async (
    { page, per_page, orgId }: Pagination,
    thunkAPI
  ) => {
    let response: any;
    if (orgId) {
      response = await fetchOrganizationList(page, per_page, orgId);
      response.orgId = orgId;
    } else {
      response = await fetchOrganizationList(page, per_page);
    }
    return response;
  }
);

export const fetchOrganizationDetailsAsync = createAsyncThunk(
  "user/fetchOrgDetails",
  async (orgId: number) => {
    const response: any = await fetchOrganizationDetails(orgId);
    return response;
  }
);

export const loginUserAsync = createAsyncThunk(
  "user/Login",
  async (data: any, thunkAPI) => {
    const response = await login(data);
    return response;
  }
);

export const loginWithGoogleAsync = createAsyncThunk(
  "user/LoginWithGoogle",
  async (idToken: string, { rejectWithValue }) => {
    try {
      const response = await loginWithGoogle(idToken);
      return response;
    } catch (error: any) {
      console.error("Error in loginWithGoogleAsync:", error);
      return rejectWithValue(error?.response?.data?.msg || "Google login failed");
    }
  }
);

export const createOrganizationAsync = createAsyncThunk(
  "user/CreateOrg",
  async (data: any, thunkAPI) => {
    const response = await CreateOrganization(data);
    return response;
  }
);

export const createUserAsync = createAsyncThunk(
  "user/CreateUser",
  async (data: any, { rejectWithValue }) => {
    try {
      return await CreateUser(data);
    } catch (error: any) {
      console.error("Error in createUserAsync:", error);
      return rejectWithValue(error?.message);
    }
  }
);

export const getUserAccountDetailsAsync = createAsyncThunk(
  "user/getUserAccountDetails",
  async () => {
    const response: any = await getUserAccountDetails();
    return response;
  }
);

export const fetchOrganizationHierarchyAsync = createAsyncThunk(
  "user/fetchOrganizationHierarchy",
  async (orgId: number) => {
    const response: any = await fetchOrganizationHierarchy(orgId);
    return response;
  }
);



export const fetchOrganizationSummaryAsync = createAsyncThunk(
  "user/fetchOrganizationSummary",
  async (orgId: number) => {
    const response: any = await fetchOrganizationSummary(orgId);
    return response;
  }
);

export const fetchUserStatsAsync = createAsyncThunk(
  "user/fetchUserStats",
  async () => {
    const response = await fetchUserStats();
    return response;
  }
);